var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uploadButton"},[_c('p',[_vm._v("ファイルを選択")]),_c('input',{ref:"file",attrs:{"type":"file"},on:{"change":_vm.onFileChange,"click":_vm.onClick}}),(_vm.selectedFile)?_c('div',{staticClass:"selected-file-name"},[_vm._v(_vm._s(_vm.selectedFile.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }